import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { DataService } from '../services/data.service';


@Component({
  selector: 'app-accessioning-list',
  templateUrl: './accessioning-list.component.html',
  styleUrls: ['./accessioning-list.component.css']
})
export class AccessioningListComponent {

  @ViewChild('dt') dt: Table | undefined;

  accessioningList: any[] = [];
  loading: boolean = true;
  selectedSample: any;
  cols: any[] = [];

  constructor(private dataService: DataService,
    private router: Router) { }

  ngOnInit() {
    const filters = localStorage.getItem("filters");

    this.dataService.getAccessioningList().then(data => {
      this.accessioningList = data;
      this.loading = false;
    });
    this.cols = [
      { field: 'instrument', header: 'Instrument' },
      { field: 'sourcePlate', header: 'Source Plate' },
      { field: 'sourceWell', header: 'Source Well' },
      { field: 'tip', header: 'Tip' },
      { field: 'destPlate', header: 'Destination Plate' },
      { field: 'destWell', header: 'Destination Well' },
      //{ field: 'deckPosition', header: 'Deck Position' },
      { field: 'startDate', header: 'Start Date' },
      { field: 'retry', header: 'Retry' },
      //{ field: 'endDate', header: 'End Date' },
      { field: 'accessionIncident', header: 'Last Accessioning Incident' },
      { field: 'accessionIncidentDate', header: 'Last Accessioning Incident Date' },
      { field: 'accessionService', header: 'Last Accessioning Service' },
      { field: 'accessionServiceDate', header: 'Last Accessioning Service Date' }
    ]
  }

  clear(table: Table) {
      table.clear();
  }

  applyFilterGlobal($event:any) {
    var filter = ($event.target as HTMLInputElement).value;

    this.dt?.filterGlobal(filter, "contains");
  }

  rowClick(record: any){
    //this.router.navigate(['detail',snpRecord.sampleId]);
  }
}
